import { getBoardRoles } from '../../../../../../../../store/model/board/selectors/getBoardRoles';
import { getBoard } from '../../../../../../../../store/model/selectors/getBoardById';
import { createSelector } from 'reselect';

export const getBoardRolesCreateSelector = (
) => createSelector(
    getBoard,
    getBoardRoles
);
